/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/use-auth";
import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import { generateImageSlide } from "./utils";
import { isArrayNotEmpty } from "utils/empty-exists";

const ImageGalleryGrid = (props) => {
    
    const { token } = useAuth();
    const { image_gallery } = props || {};
    const [slides, setSlides] = useState([]);
    const [index, setIndex] = useState(-1);
    const showToggle = true;
    const descriptionTextAlign = "start";
    const descriptionMaxLines = 3;

    useEffect(() => {
        if (image_gallery && image_gallery.length > 0) {
            generateImageSlide(image_gallery, token).then((result) => setSlides(result));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [image_gallery]);

    return (
        <div className='simplicity-image-list-item'>
            {isArrayNotEmpty(slides) &&
                <>
                    <PhotoAlbum
                        layout='rows'
                        photos={slides}
                        targetRowHeight={200}
                        onClick={({ index: current }) => setIndex(current)}
                    />
                    <Lightbox
                        index={index}
                        slides={slides}
                        open={index >= 0}
                        close={() => setIndex(-1)}
                        plugins={[Captions, Fullscreen]}
                        captions={{ showToggle, descriptionTextAlign, descriptionMaxLines }}
                    />
                </>
            }
        </div>
    );
};

export { ImageGalleryGrid };
